module.exports = __webpack_public_path__ + "static/media/18ECA25.0c087863.jpg";